import { Suspense } from 'react'
import { ThemeProvider } from '@material-tailwind/react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import AppRouting from './AppRouting'
import CookieConsentBanner from './components/CookieConsentBanner'
import ExpiredRedirect from './components/ExpiredRedirect'
import OnboardingTutorial from './components/OnboardingTutorial'
import { DarkModeProvider } from './contexts/DarkModeContext'
import { FontSizeProvider } from './contexts/FontSizeContext'
import LabelsContextProvider from './contexts/LabelsContext'
import { SessionContextProvider } from './contexts/SessionContext'
import UserPreferencesContextProvider from './contexts/UserPreferencesContext'
import { customTheme } from './theme/theme'
import { LanguageContextProvider } from './contexts/LanguageContext'
import Loading from './layout/Loading'

const App: React.FC = () => (
  <>
    <ToastContainer
      enableMultiContainer
      containerId="general-toast-container"
      position="bottom-left"
      autoClose={4000}
      closeButton
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />

    <ToastContainer
      enableMultiContainer
      containerId="interactive-toast-container"
      position="bottom-center"
      autoClose={false}
      closeButton={false}
      hideProgressBar
      newestOnTop
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      theme="dark"
    />

    <BrowserRouter>
      <ThemeProvider value={customTheme}>
        <DarkModeProvider>
          <LanguageContextProvider>
            <FontSizeProvider>
              <SessionContextProvider>
                <UserPreferencesContextProvider>
                  <Suspense fallback={<Loading />}>
                    <LabelsContextProvider>
                      <CookieConsentBanner />
                      <OnboardingTutorial />
                      <AppRouting />
                      <ExpiredRedirect />
                    </LabelsContextProvider>
                  </Suspense>
                </UserPreferencesContextProvider>
              </SessionContextProvider>
            </FontSizeProvider>
          </LanguageContextProvider>
        </DarkModeProvider>
      </ThemeProvider>
    </BrowserRouter>
  </>
)

export default App
